import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { chris } from "../characters/Chris";
import { mc } from "../characters/MC";
import { images } from "./images";
import { V5ChrisRandomGirlTalk } from "./V5_Merry";
import { V6ChrisMerryAfter } from "./V6";

export const V6ChrisMerry = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_1);
    chris.talk(`YO ${mc.name} WAIT UP!`, { method: "Shouting" });
    ImageClass.setImage(images.v5.ChrisMerry_8);
    chris.talk(`What's up? I almost missed you there.`);
    mc.talk(`Hey.`);
    ImageClass.setImage(images.v5.ChrisMerry_9);
    chris.talk(`I saw you were sitting with that old dude, what was that about?`);
    mc.talk(`Nothing... I just helped Vanessa with something.`);
    ImageClass.setImage(images.v5.ChrisMerry_10);
    chris.talk(`Oh cool.`);
    if (mc.properties.joeStatus === "enemy") {

        chris.talk(`Good to see you are getting along after all that happened with her boyfriend.`);
        mc.talk(`Yeah we are cool... I think.`);
    } else {

    }
    ImageClass.setImage(images.v5.ChrisMerry_8);
    chris.talk(`There is something I wanted to talk to you about but I didn't have the chance. Do you have a minute?`);
    mc.talk(`Sure.`);

    chris.talk(`What do you think of the girl behind me?`);
    mc.talk(`She looks kinda angry... But she is fine I guess, why?`);
    chris.talk(`She is more than fine, trust me.`);
    mc.talk(`Okay... Where are you going with this?`);

    chris.talk(`I want to offer you a deal.`);
    chris.talk(`That girl is just one of many girls that are coming here and are just looking for a good time, if you know what I mean.`);

    chris.talk(`But sometimes I want to meet girls that don't use bars as their usual hangout place.`);
    chris.talk(`And I believe you don't meet girls in bars that often.`);
    mc.talk(`Right.`);
    chris.talk(`So what I want to say is that I'll be happy to point the girls I meet in your direction once I'm done with them as long as you do the same.`);

    return jump(V6ChrisMerry_Question, "V6ChrisMerry_Question");
};


export const V6ChrisMerry_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_9);
    await chris.setQuestion(new Question({ text: `We can start right now with that girl.\nWhat do you say?`, options: { think: false }, key: 'v6AgreedToChrisProposal' })
        .option({ title: `Agree`, key: true })
        .option({ title: `Refuse`, key: false }));

    if (Question.globalAnswers.v6AgreedToChrisProposal) {

        return jump(V6ChrisMerry_Question_Agree, "V6ChrisMerry_Question_Agree");
    } else {

        return jump(V6ChrisMerry_Question_Refuse, "V6ChrisMerry_Question_Refuse");
    }
};



export const V6ChrisMerry_Question_Agree = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_9);
    await mc.set((properties) => {
        properties.agreeToChrisProposal = true;
    });
    mc.talk(`Sounds good.`);
    ImageClass.setImage(images.v5.ChrisMerry_8);
    chris.talk(`Great!`);
    chris.talk(`Well, she is all yours, have fun.`);
    mc.talk(`Don't mind if I do.`);

    return jump(V5ChrisRandomGirlTalk, "V5ChrisRandomGirlTalk");
};



export const V6ChrisMerry_Question_Refuse = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_10);
    await mc.set((properties) => {
        properties.agreeToChrisProposal = false;
    });
    mc.talk(`I think I'll pass.`);
    chris.talk(`Too bad bro.`);
    chris.talk(`Well, hit me up if you ever change your mind.`);
    mc.talk(`Sure, cya.`);

    return jump(V6ChrisMerryEnd, "V6ChrisMerryEnd");
};


export const V6ChrisMerryEnd = async (): Promise<any> => {


    return jump(V6ChrisMerryAfter, "V6ChrisMerryAfter");
};




